import React from 'react';

import { DefaultContext, useApolloClient } from '@apollo/client';

import { mergeObjects } from '@hrlogics/helper-utils';

import type { CognitoGetUserMfaStatusQuery, CognitoGetUserMfaStatusQueryVariables } from 'src/api';
import { CognitoGetUserMfaStatusDocument, useCognitoDisableUserMfaMutation } from 'src/api';

type DisableUserMfaHookParams = {
  context?: DefaultContext;
};

export const useDisableUserMfa = (params: DisableUserMfaHookParams = {}) => {
  const apolloClient = useApolloClient();

  const [disableUserMfaMutation, { loading }] = useCognitoDisableUserMfaMutation(params);

  const disableUserMfa = React.useCallback(
    async (userId: string) => {
      await disableUserMfaMutation({
        variables: {
          userId,
        },
        onCompleted: () => {
          const options = {
            query: CognitoGetUserMfaStatusDocument,
            variables: {
              userId,
            },
          };

          const queryData = apolloClient.readQuery<
            CognitoGetUserMfaStatusQuery,
            CognitoGetUserMfaStatusQueryVariables
          >(options);

          try {
            if (queryData) {
              apolloClient.writeQuery<CognitoGetUserMfaStatusQuery>({
                ...options,
                data: mergeObjects(queryData, {
                  cognitoGetUserMfaStatus: { mfaEnabled: false },
                }),
              });
            }
          } catch (error) {
            console.error(error);
          }
        },
      });
    },
    [disableUserMfaMutation, apolloClient],
  );

  return {
    disableUserMfa,
    loading,
  };
};
